export const AMO_CRM_REDIRECT_URI = 'https://uysot.uz';
